module.exports = __webpack_public_path__ + "static/img/success_npc.59b04a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/success_npc.png
// module id = uE7o
// module chunks = 0